import chroma from "chroma-js";
import RcColorPicker from "rc-color-picker";
import React, { useState, useEffect } from "react";

import { debounce } from "../../util/func";

import "./index.scss";
import "rc-color-picker/assets/index.css";

export default (props) => {
  const { onChange, value } = props;

  const [rgba, setRGBA] = useState([]);

  const debounceChange = debounce(onChange, 260);

  useEffect(() => {
    if (value) {
      setRGBA(chroma(value).rgba());
    }
  }, [value]);

  return (
    <div className="select-colorpicker">
      <RcColorPicker
        placement="bottomRight"
        color={chroma(rgba[0], rgba[1], rgba[2]).hex()}
        alpha={Math.round(rgba[3] * 100)}
        onChange={(e) => {
          debounceChange(
            chroma(e.color)
              .alpha(Number((e.alpha / 100).toFixed(1)))
              .css()
          );
        }}
      />
    </div>
  );
};

export const HexColorPicker = (props) => {
  const { onChange, value } = props;

  return (
    <div
      id="color-picker"
      style={{
      position: 'relative',
      zIndex: 10000,
    }}>
      <RcColorPicker
        getCalendarContainer={() => document.getElementById('color-picker')}
        color={value}
        placement="bottomRight"
        onChange={(e) => {
          onChange(e.color);
        }}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Select/ColorPicker.js